// Main sample data file - imports and combines all domain data
import { workProjectsData } from './domains/workProjects.js';
import { personalDevelopmentData } from './domains/personalDevelopment.js';
import { healthWellnessData } from './domains/healthWellness.js';
import { creativeProjectsData } from './domains/creativeProjects.js';

// Combine all domain data into a single structure
export const sampleMementoData = {
  nodes: [
    // Domain Hubs (Level 0)
    workProjectsData.hub,
    personalDevelopmentData.hub,
    healthWellnessData.hub,
    creativeProjectsData.hub,

    // Project Clusters (Level 1)
    ...workProjectsData.clusters,
    ...personalDevelopmentData.clusters,
    ...healthWellnessData.clusters,
    ...creativeProjectsData.clusters,

    // Topic Areas (Level 2)
    ...workProjectsData.areas,
    ...personalDevelopmentData.areas,
    ...healthWellnessData.areas,
    ...creativeProjectsData.areas,

    // Conversation Mementos (Level 3)
    ...workProjectsData.mementos,
    ...personalDevelopmentData.mementos,
    ...healthWellnessData.mementos,
    ...creativeProjectsData.mementos
  ],

  edges: [
    // Hierarchical edges (Level 0 -> 1: Hubs to Clusters)
    {
      source: "hub_work_projects",
      target: "cluster_saas_platform",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_work_projects",
      target: "cluster_ai_integration",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_personal_development",
      target: "cluster_career_growth",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_personal_development",
      target: "cluster_tech_learning",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_health_wellness",
      target: "cluster_fitness_routine",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_health_wellness",
      target: "cluster_mental_health",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_creative_projects",
      target: "cluster_novel_writing",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "hub_creative_projects",
      target: "cluster_music_production",
      type: "hierarchy",
      weight: 3
    },

    // Hierarchical edges (Level 1 -> 2: Clusters to Areas)
    {
      source: "cluster_saas_platform",
      target: "area_backend_architecture",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_saas_platform",
      target: "area_frontend_optimization",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_ai_integration",
      target: "area_llm_integration",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_ai_integration",
      target: "area_vector_databases",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_career_growth",
      target: "area_interview_prep",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_career_growth",
      target: "area_leadership_skills",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_tech_learning",
      target: "area_react_advanced",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_tech_learning",
      target: "area_system_design",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_fitness_routine",
      target: "area_strength_training",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_fitness_routine",
      target: "area_nutrition_tracking",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_mental_health",
      target: "area_anxiety_management",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_mental_health",
      target: "area_therapy_insights",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_novel_writing",
      target: "area_character_development",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_novel_writing",
      target: "area_plot_structure",
      type: "hierarchy",
      weight: 3
    },
    {
      source: "cluster_music_production",
      target: "area_songwriting",
      type: "hierarchy",
      weight: 3
    },

    // Hierarchical edges (Level 2 -> 3: Areas to Mementos)
    // Work Projects
    {
      source: "area_backend_architecture",
      target: "memento_001",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_backend_architecture",
      target: "memento_002",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_frontend_optimization",
      target: "memento_003",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_frontend_optimization",
      target: "memento_004",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_llm_integration",
      target: "memento_005",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_llm_integration",
      target: "memento_006",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_vector_databases",
      target: "memento_007",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_vector_databases",
      target: "memento_008",
      type: "hierarchy",
      weight: 2
    },

    // Personal Development
    {
      source: "area_interview_prep",
      target: "memento_009",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_interview_prep",
      target: "memento_010",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_leadership_skills",
      target: "memento_011",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_leadership_skills",
      target: "memento_012",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_react_advanced",
      target: "memento_013",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_react_advanced",
      target: "memento_014",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_system_design",
      target: "memento_015",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_system_design",
      target: "memento_016",
      type: "hierarchy",
      weight: 2
    },

    // Health & Wellness
    {
      source: "area_strength_training",
      target: "memento_017",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_strength_training",
      target: "memento_018",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_nutrition_tracking",
      target: "memento_019",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_nutrition_tracking",
      target: "memento_020",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_anxiety_management",
      target: "memento_021",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_anxiety_management",
      target: "memento_022",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_therapy_insights",
      target: "memento_023",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_therapy_insights",
      target: "memento_024",
      type: "hierarchy",
      weight: 2
    },

    // Creative Projects
    {
      source: "area_character_development",
      target: "memento_025",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_character_development",
      target: "memento_026",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_plot_structure",
      target: "memento_027",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_plot_structure",
      target: "memento_028",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_songwriting",
      target: "memento_029",
      type: "hierarchy",
      weight: 2
    },
    {
      source: "area_songwriting",
      target: "memento_030",
      type: "hierarchy",
      weight: 2
    },

    // Semantic edges (related content within same areas)
    {
      source: "memento_001",
      target: "memento_002",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_003",
      target: "memento_004",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_005",
      target: "memento_006",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_007",
      target: "memento_008",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_009",
      target: "memento_010",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_011",
      target: "memento_012",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_013",
      target: "memento_014",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_015",
      target: "memento_016",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_017",
      target: "memento_018",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_019",
      target: "memento_020",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_021",
      target: "memento_022",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_023",
      target: "memento_024",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_025",
      target: "memento_026",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_027",
      target: "memento_028",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_029",
      target: "memento_030",
      type: "semantic",
      weight: 1
    },

    // Cross-topic semantic edges (related concepts across different areas)
    // React knowledge connects work and learning
    {
      source: "memento_003",
      target: "memento_013",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_004",
      target: "memento_013",
      type: "semantic",
      weight: 1
    },
    // AI/LLM work connects to vector databases
    {
      source: "memento_005",
      target: "memento_007",
      type: "semantic",
      weight: 1
    },
    {
      source: "memento_006",
      target: "memento_008",
      type: "semantic",
      weight: 1
    },
    // System design knowledge applies to work architecture
    {
      source: "memento_015",
      target: "memento_001",
      type: "cross-topic",
      weight: 1
    },
    {
      source: "memento_016",
      target: "memento_002",
      type: "cross-topic",
      weight: 1
    },
    // Interview prep connects to work experience
    {
      source: "memento_009",
      target: "memento_001",
      type: "cross-topic",
      weight: 1
    },
    {
      source: "memento_010",
      target: "memento_002",
      type: "cross-topic",
      weight: 1
    },

    // Cross-domain connections (stress/health impacts work performance)
    {
      source: "memento_021",
      target: "memento_009",
      type: "cross-topic",
      weight: 1
    },
    {
      source: "memento_022",
      target: "memento_011",
      type: "cross-topic",
      weight: 1
    },
    // Self-compassion helps with leadership
    {
      source: "memento_024",
      target: "memento_011",
      type: "cross-topic",
      weight: 1
    },

    // Creative and technical crossover (structure and storytelling)
    {
      source: "memento_027",
      target: "memento_015",
      type: "cross-topic",
      weight: 1
    },
    {
      source: "memento_026",
      target: "memento_014",
      type: "cross-topic",
      weight: 1
    },
    // Writing discipline connects to fitness discipline
    {
      source: "memento_025",
      target: "memento_017",
      type: "cross-topic",
      weight: 1
    }
  ],

  stats: {
    totalNodes: 35,
    hubs: 4,
    clusters: 8,
    topicAreas: 13,
    mementos: 30,
    totalEdges: 68,
    hierarchy: {
      levels: 4,
      mainDomains: 4,
      avgMementosPerArea: 2.3,
      avgDepth: 4
    },
    visibility: {
      public: 12,
      private: 12,
      askMe: 11
    }
  }
};

// Helper functions for accessing the data
export const getSampleMementoData = () => sampleMementoData;

export const getMementosByVisibility = (visibility) => {
  return sampleMementoData.nodes.filter(node => node.visibility === visibility);
};

export const getMementosByLevel = (level) => {
  return sampleMementoData.nodes.filter(node => node.level === level);
};

export const getMementosByCategory = (category) => {
  return sampleMementoData.nodes.filter(node => node.category === category);
};

export const getMementosByDomain = (hubId) => {
  return sampleMementoData.nodes.filter(node => 
    node.parentHub === hubId || node.id === hubId
  );
};

export const getNodeById = (nodeId) => {
  return sampleMementoData.nodes.find(node => node.id === nodeId);
};

export const getChildNodes = (parentId) => {
  return sampleMementoData.nodes.filter(node => 
    node.parentHub === parentId || 
    node.parentCluster === parentId || 
    node.parentArea === parentId
  );
};

export const getRelatedMementos = (mementoId) => {
  const edges = sampleMementoData.edges.filter(edge => 
    edge.source === mementoId || edge.target === mementoId
  );
  
  return edges.map(edge => {
    const relatedId = edge.source === mementoId ? edge.target : edge.source;
    return {
      node: getNodeById(relatedId),
      relationship: edge.type,
      weight: edge.weight
    };
  });
};

// Backward compatibility function
export const generateSampleData = () => {
  return {
    nodes: sampleMementoData.nodes,
    edges: sampleMementoData.edges,
    stats: sampleMementoData.stats
  };
};
